// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"bd1c7f5e","453":"887ca1b3","732":"00865524","762":"4cc69355","977":"cc3cca89"}[chunkId] + ".chunk.js";
};